import { render, staticRenderFns } from "./wy-home-auto-qa-panel-table-summary.vue?vue&type=template&id=59965cd6&"
import script from "./wy-home-auto-qa-panel-table-summary.vue?vue&type=script&lang=js&"
export * from "./wy-home-auto-qa-panel-table-summary.vue?vue&type=script&lang=js&"
import style0 from "./wy-home-auto-qa-panel-table-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports